import type { O5AwsDeployerV1EnvironmentKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const O5_ENVIRONMENT_BASE_PATH = getResolvedPath('/tech-ops/environment');

export const getO5EnvironmentPath: EntityPathBuilder<O5AwsDeployerV1EnvironmentKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return O5_ENVIRONMENT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.environmentId) {
        return undefined;
      }

      return getResolvedPath(`${O5_ENVIRONMENT_BASE_PATH}/$environmentId`, context?.keys);
    }
  }
};

export function getO5EnvironmentDetailPath(environmentId: string | undefined) {
  if (!environmentId) {
    return undefined;
  }

  return getO5EnvironmentPath({ kind: 'detail', keys: { environmentId } });
}
